import { useEffect, RefObject } from "react";
import { TIMELINE_TRACK_HEIGHT } from "../constants/global";


export const useScrollToNow = (viewportRef: RefObject<HTMLDivElement>) => {
    useEffect(() => {
        if (!viewportRef.current) return
        const container = viewportRef.current
  
        // convert rem‐based row height into pixels
        const rem = parseFloat(TIMELINE_TRACK_HEIGHT.replace('rem',''))
        const rootPx = parseFloat(getComputedStyle(document.documentElement).fontSize)
        const hourRowPx = rem * rootPx
  
        const now = new Date()
        const y = (now.getHours() + now.getMinutes() / 60) * hourRowPx
  
        // “push down” as far as possible but keep the now‐line visible:
        const maxScroll = container.scrollHeight - container.clientHeight
        container.scrollTop = Math.min(y, maxScroll)
  
    }, []);
}